import * as React from 'react';
import s from './PriceQuotesBusinessInfo.scss';
import get from 'lodash.get';
import { Box, Text } from '@wix/design-system';
import { addressFormatter } from '@wix/crm-financial-formatters';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { Placement, } from '@wix/ambassador-wix-quotes-web/types';
import { WithBusinessInfoLoader, } from '../../loaders/loaders-builder';
import { isMobileView } from '../../../core/isMobileView';
import { getLogoUrl } from '../Logo/getLogoUrl';
const customaizeInvoiceVerticalLayoutLineProps = {
    size: 'tiny',
    secondary: true,
    weight: 'thin',
};
const BusinessInfoLine = ({ children, verticalLayout, ...props }) => (React.createElement(Box, { wordBreak: "break-word" },
    React.createElement(Text
    // @ts-expect-error
    , { 
        // @ts-expect-error
        size: "tiny", 
        // @ts-expect-error
        secondary: true, 
        // @ts-expect-error
        weight: "thin", ...(verticalLayout ? customaizeInvoiceVerticalLayoutLineProps : {}), ...props, className: `${s.customizeBusinessInfoLine} ${props.className || ''}` }, children)));
const PriceQuotesBusinessInfoComponent = ({ t, businessInfo, verticalLayout, onImageReady = () => { }, businessCustomFields, }) => {
    const { name, email, phone, companyId, logo } = businessInfo;
    const description = get(businessInfo, 'businessAddress.description.content');
    const placement = get(businessInfo, 'businessAddress.description.placement');
    const city = get(businessInfo.businessAddress?.address, 'city');
    const state = get(businessInfo.businessAddress?.address, 'subdivision');
    const country = get(businessInfo.businessAddress?.address, 'country');
    const streetName = get(businessInfo.businessAddress?.address, 'streetAddress.name');
    const streetNumber = get(businessInfo.businessAddress?.address, 'streetAddress.number');
    const street = get(businessInfo.businessAddress?.address, 'street');
    const zip = get(businessInfo.businessAddress?.address, 'postalCode');
    const localizedLocation = addressFormatter({
        t,
        // @ts-expect-error
        city,
        // @ts-expect-error
        state,
        // @ts-expect-error
        country,
        // @ts-expect-error
        zip,
        streetNumber,
        streetName,
        street,
    });
    const Location = () => localizedLocation ? (React.createElement(BusinessInfoLine, { dataHook: "business-address", verticalLayout: true }, localizedLocation)) : null;
    const Description = () => description ? (React.createElement(BusinessInfoLine, { dataHook: "business-address-description", verticalLayout: true }, description)) : null;
    const hasLogo = () => logo && logo.match(/(?:[^\/]+)$/);
    const Logo = () => {
        const handleLogoNotExist = () => {
            onImageReady();
            return React.createElement("div", { style: { height: '10px' } });
        };
        const width = verticalLayout ? 622 : 200;
        return hasLogo() ? (React.createElement("div", { className: s.logo, "data-hook": "business-logo" },
            React.createElement("img", { alt: name, decoding: "sync", src: getLogoUrl(logo, { maxWidth: width, maxHeight: 200 }), onError: ({ target: image }) => {
                    image.parentElement.style.display = 'none';
                    onImageReady();
                }, onLoad: onImageReady }))) : (handleLogoNotExist());
    };
    const customFields = () => (businessCustomFields ?? []).map(({ displayName, value }, index) => (React.createElement("div", { key: index },
        React.createElement(BusinessInfoLine, { verticalLayout: true, dataHook: `${displayName}-${index}-custom-field`, className: s.customFieldLine }, t('invoice-view:price-quote.view.custom-field', {
            displayName,
            value,
        })))));
    const renderAddress = () => {
        switch (placement) {
            case Placement.Replace:
                return description ? React.createElement(Description, null) : [React.createElement(Location, { key: "location" })];
            case Placement.Before:
                return [React.createElement(Description, { key: "description" }), React.createElement(Location, { key: "location" })];
            case Placement.After:
                return [React.createElement(Location, { key: "location" }), React.createElement(Description, { key: "description" })];
            default:
                return [React.createElement(Location, { key: "location" })];
        }
    };
    const hasCustomFields = businessCustomFields && businessCustomFields.length > 0;
    return (React.createElement("div", { className: `${s.businessInfo} ${verticalLayout ? s.verticalLayout : ''}` },
        React.createElement(Logo, null),
        React.createElement(Box, { direction: isMobileView() ? 'vertical' : 'horizontal' },
            React.createElement("div", { className: s.businessInfoDetails, "data-hook": "business-info" },
                !!name && (React.createElement(BusinessInfoLine, { className: s.businessName, weight: "bold", dataHook: "business-name", verticalLayout: true }, name)),
                renderAddress(),
                !!email && (React.createElement(BusinessInfoLine, { dataHook: "business-email", verticalLayout: true }, email)),
                !!phone && (React.createElement(BusinessInfoLine, { dataHook: "business-phone", verticalLayout: true }, t('invoice-view:price-quote.view.business.phone', { phone }))),
                !!companyId && (React.createElement(BusinessInfoLine, { dataHook: "business-company-id", verticalLayout: true }, t('invoice-view:price-quote.view.business.company-id', {
                    companyId,
                })))),
            hasCustomFields && (React.createElement("div", { className: `${s.businessInfoDetails} ${s.businessCustomFields}`, "data-hook": "business-custom-fields", style: {
                    width: !hasLogo() ? '210px' : undefined,
                    marginTop: hasLogo() ? '47px' : '104px',
                } }, customFields())))));
};
export const PriceQuotesBusinessInfo = WithBusinessInfoLoader(withTranslation(['invoice-view', 'locale-data'])(PriceQuotesBusinessInfoComponent));
//# sourceMappingURL=PriceQuotesBusinessInfo.js.map